import { IViewingAttendee } from '@/models/viewing.model';

export const groupViewingAttendeesByDate = (attendees: IViewingAttendee[]): Record<string, IViewingAttendee[]> => {
  return attendees.reduce<Record<string, IViewingAttendee[]>>((acc, attendee) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { viewing_time } = attendee;
    if (!acc[viewing_time]) {
      acc[viewing_time] = [];
    }
    acc[viewing_time].push(attendee);
    return acc;
  }, {});
};
